import { Page } from '../../types'

const suspectedBribery: Page[] = [
    {
        pageType: 'question',
        title: 'Allegations of suspected bribery',
        name: 'allegations-of-suspected-bribery',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'bribery-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'bribery-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'bribery-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default suspectedBribery
